export default "__VITE_ASSET__d1a89489__"